
// ── Blueprint palette (literal hex, light-mode only — no CSS vars) ────────────
// paper:#f4efe6  paper-2:#efe8db  card:#fbf8f1
// ink:#14181f    ink-soft:#3a414e  muted:#6b7280
// line:#cdbfa6   hi:#ff5a1f  hi-deep:#e2410a  hi-wash:rgba(255,90,31,.12)
// ok:#1f9d6b     warn:#d9920a  info:#2b6cb0
// radius: 7px  fonts: IBM Plex Mono / Bricolage Grotesque / IBM Plex Sans

// ─────────────────────────────────────────────────────────────────────────────
// 1. MOBILE MOCKUP — phone frame with floor-plan, hi-vis markers, offline bar
// ─────────────────────────────────────────────────────────────────────────────

export function MobileMockup() {
  return (
    <div
      aria-label="Mockup aplikacji mobilnej: rzut obiektu z markerami inspekcji i trybem offline"
      role="img"
      style={{
        width: 286,
        maxWidth: '100%',
        margin: '0 auto',
        background: '#14181f',
        borderRadius: 42,
        padding: 11,
        boxShadow: '14px 14px 0 rgba(20,24,31,0.08)',
        flexShrink: 0,
      }}
    >
      {/* Screen */}
      <div
        aria-hidden="true"
        style={{
          background: '#f4efe6',
          borderRadius: 32,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        {/* Notch */}
        <div
          style={{
            height: 26,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            background: '#f4efe6',
          }}
        >
          <div
            style={{
              width: 70,
              height: 16,
              background: '#14181f',
              borderRadius: '0 0 12px 12px',
              position: 'absolute',
              top: 0,
            }}
          />
        </div>

        {/* Top bar */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '8px 14px 10px',
            borderBottom: '1.5px solid #14181f',
          }}
        >
          <span
            style={{ fontSize: 18, color: '#14181f', lineHeight: 1 }}
          >‹</span>
          <span>
            <span
              style={{
                display: 'block',
                fontFamily: "'Bricolage Grotesque', serif",
                fontWeight: 700,
                fontSize: 15,
                lineHeight: 1,
                color: '#14181f',
              }}
            >Centrum Północ</span>
            <span
              style={{
                display: 'block',
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 8.5,
                letterSpacing: '0.12em',
                textTransform: 'uppercase',
                color: '#6b7280',
                marginTop: 2,
              }}
            >Obiekt A-01 · 24 markery</span>
          </span>
        </div>

        {/* Floor plan area */}
        <div
          style={{
            position: 'relative',
            height: 248,
            background: '#fbf8f1',
            backgroundImage:
              'linear-gradient(rgba(20,24,31,0.06) 1px,transparent 1px),linear-gradient(90deg,rgba(20,24,31,0.06) 1px,transparent 1px)',
            backgroundSize: '20px 20px',
            overflow: 'hidden',
          }}
        >
          {/* Walls */}
          <div style={{ position: 'absolute', left: '8%', top: '10%', width: '84%', height: 2, background: '#14181f', opacity: 0.72 }} />
          <div style={{ position: 'absolute', left: '8%', top: '10%', width: 2, height: '76%', background: '#14181f', opacity: 0.72 }} />
          <div style={{ position: 'absolute', left: '8%', bottom: '14%', width: '84%', height: 2, background: '#14181f', opacity: 0.72 }} />
          <div style={{ position: 'absolute', right: '8%', top: '10%', width: 2, height: '76%', background: '#14181f', opacity: 0.72 }} />
          <div style={{ position: 'absolute', left: '50%', top: '10%', width: 2, height: '44%', background: '#14181f', opacity: 0.72 }} />

          {/* Rooms */}
          <div style={{ position: 'absolute', left: '14%', top: '16%', width: '30%', height: '30%', border: '1.5px solid #cdbfa6', background: 'rgba(255,255,255,0.4)' }} />
          <div style={{ position: 'absolute', left: '56%', top: '16%', width: '30%', height: '34%', border: '1.5px solid #cdbfa6', background: 'rgba(255,255,255,0.4)' }} />

          {/* Marker 18 — hi (orange) */}
          <div
            style={{
              position: 'absolute', left: '22%', top: '26%',
              width: 28, height: 28, borderRadius: '50%',
              background: '#ff5a1f',
              display: 'grid', placeItems: 'center',
              fontFamily: "'IBM Plex Mono', monospace",
              fontWeight: 600, fontSize: 11, color: '#fff',
              border: '2px solid #fff',
              boxShadow: '0 4px 9px rgba(0,0,0,0.28)',
            }}
          >18</div>
          <div
            style={{
              position: 'absolute', left: '31%', top: '22%',
              fontFamily: "'IBM Plex Mono', monospace", fontSize: 8.5,
              color: '#14181f', background: '#fbf8f1',
              border: '1px solid #cdbfa6', padding: '1px 5px', borderRadius: 3,
              whiteSpace: 'nowrap',
            }}
          >M-18 · zawilgocenie</div>

          {/* Marker 19 — warn (amber) */}
          <div
            style={{
              position: 'absolute', right: '20%', top: '34%',
              width: 28, height: 28, borderRadius: '50%',
              background: '#d9920a',
              display: 'grid', placeItems: 'center',
              fontFamily: "'IBM Plex Mono', monospace",
              fontWeight: 600, fontSize: 11, color: '#fff',
              border: '2px solid #fff',
              boxShadow: '0 4px 9px rgba(0,0,0,0.28)',
            }}
          >19</div>

          {/* Marker 20 — info (blue) */}
          <div
            style={{
              position: 'absolute', left: '40%', bottom: '22%',
              width: 28, height: 28, borderRadius: '50%',
              background: '#2b6cb0',
              display: 'grid', placeItems: 'center',
              fontFamily: "'IBM Plex Mono', monospace",
              fontWeight: 600, fontSize: 11, color: '#fff',
              border: '2px solid #fff',
              boxShadow: '0 4px 9px rgba(0,0,0,0.28)',
            }}
          >20</div>
        </div>

        {/* Offline / sync bar */}
        <div
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '9px 14px',
            borderTop: '1.5px solid #14181f',
            background: '#fbf0d8',
          }}
        >
          <span
            style={{
              fontFamily: "'IBM Plex Mono', monospace", fontSize: 11,
              color: '#d9920a', fontWeight: 600,
              display: 'flex', alignItems: 'center', gap: 6,
            }}
          >
            <span
              style={{
                display: 'inline-flex', alignItems: 'center', gap: 5,
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 9.5, fontWeight: 600,
                letterSpacing: '0.05em', textTransform: 'uppercase',
                padding: '3px 8px', borderRadius: 999,
                border: '1px solid #d9920a',
                color: '#d9920a', background: 'rgba(217,146,10,0.12)',
              }}
            >
              <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#d9920a', display: 'inline-block' }} />
            </span>
            Offline · 3 do wysłania
          </span>
          <span
            style={{
              fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
              background: '#ff5a1f', color: '#fff',
              padding: '4px 9px', borderRadius: 5,
            }}
          >Synchronizuj</span>
        </div>

        {/* Bottom nav */}
        <div
          style={{
            display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)',
            borderTop: '1.5px solid #14181f',
            background: '#fbf8f1',
          }}
        >
          {[
            { label: 'Rzut', icon: '◳', active: true },
            { label: 'Lista', icon: '≣', active: false },
            { label: 'Formularz', icon: '✎', active: false },
            { label: 'Zdjęcia', icon: '▦', active: false },
          ].map((item, i) => (
            <div
              key={item.label}
              style={{
                padding: '9px 0 11px', textAlign: 'center',
                fontFamily: "'IBM Plex Mono', monospace",
                fontSize: 8.5, letterSpacing: '0.04em', textTransform: 'uppercase',
                color: item.active ? '#e2410a' : '#6b7280',
                background: item.active ? 'rgba(255,90,31,0.12)' : 'transparent',
                fontWeight: item.active ? 600 : 400,
                borderRight: i < 3 ? '1px solid #cdbfa6' : 'none',
              }}
            >
              <span style={{ display: 'block', fontSize: 15, marginBottom: 3 }}>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// 2. FORM BUILDER MOCKUP — web card with field rows, section header, type palette
// ─────────────────────────────────────────────────────────────────────────────

export function FormBuilderMockup() {
  const fields = [
    { label: 'Stan instalacji elektrycznej', tag: 'Lista' },
    { label: 'Data kontroli', tag: 'Data' },
    { label: 'Zdjęcia usterek', tag: 'Zdjęcia' },
    { label: 'Lokalizacja na rzucie', tag: 'Mapa' },
  ];

  const palette = ['Tekst', 'Liczba', 'Data', 'Lista', 'Zdjęcia', 'Lokalizacja', 'Osoba'];

  return (
    <div
      aria-label="Mockup kreatora formularzy: sekcja pól inspekcji z typami i paletą"
      role="img"
      style={{
        background: '#fbf8f1',
        border: '1.5px solid #14181f',
        borderRadius: 7,
        boxShadow: '10px 10px 0 rgba(20,24,31,0.07)',
        overflow: 'hidden',
        maxWidth: '100%',
      }}
    >
      {/* Window bar */}
      <div
        aria-hidden="true"
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '9px 14px',
          borderBottom: '1.5px solid #14181f',
          background: '#efe8db',
        }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{ width: 9, height: 9, borderRadius: '50%', border: '1.5px solid #14181f', display: 'inline-block' }}
          />
        ))}
        <span
          style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
            color: '#6b7280', marginLeft: 6, letterSpacing: '0.04em',
          }}
        >pinveo.app/admin/formularze</span>
      </div>

      {/* Body */}
      <div style={{ padding: 16 }}>
        {/* Title row */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <strong
            style={{
              fontFamily: "'Bricolage Grotesque', serif", fontWeight: 700, fontSize: 15, color: '#14181f',
            }}
          >Przegląd techniczny</strong>
          <span
            style={{
              fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
              border: '1px solid #14181f', borderRadius: 5,
              padding: '4px 9px', background: '#ff5a1f', color: '#fff',
              fontWeight: 600,
            }}
          >Zapisz szablon</span>
        </div>

        {/* Section header */}
        <div
          style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
            letterSpacing: '0.1em', textTransform: 'uppercase',
            color: '#6b7280', margin: '4px 0 9px',
          }}
        >Sekcja · Instalacje</div>

        {/* Field rows */}
        {fields.map((field) => (
          <div
            key={field.label}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '9px 11px',
              border: '1px solid #cdbfa6', borderRadius: 6,
              background: '#f4efe6', marginBottom: 8,
            }}
          >
            <span
              style={{
                fontFamily: "'IBM Plex Mono', monospace", color: '#6b7280', fontSize: 13,
              }}
            >⠿</span>
            <span style={{ flex: 1, fontSize: 13, fontWeight: 600, color: '#14181f' }}>
              {field.label}
            </span>
            <span
              style={{
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 9,
                textTransform: 'uppercase', letterSpacing: '0.06em',
                color: '#3a414e', border: '1px solid #cdbfa6',
                padding: '2px 7px', borderRadius: 4, background: '#fbf8f1',
              }}
            >{field.tag}</span>
          </div>
        ))}

        {/* Add field button */}
        <div
          style={{
            border: '1.5px dashed #cdbfa6', borderRadius: 6,
            padding: 9, textAlign: 'center',
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 11,
            color: '#6b7280',
          }}
        >+ Dodaj pole</div>

        {/* Palette */}
        <div
          style={{
            display: 'flex', flexWrap: 'wrap', gap: 6,
            marginTop: 13, paddingTop: 13,
            borderTop: '1px solid #cdbfa6',
          }}
        >
          {palette.map((chip) => (
            <span
              key={chip}
              style={{
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
                border: '1px solid #14181f', borderRadius: 5,
                padding: '4px 9px', background: '#f4efe6', color: '#14181f',
              }}
            >{chip}</span>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// 3. REPORT MOCKUP — protocol/PDF title block, field rows, photo thumbnails, signature
// ─────────────────────────────────────────────────────────────────────────────

export function ReportMockup() {
  return (
    <div
      aria-label="Mockup protokołu PDF: blok tytułowy, pola inspekcji, miniatury zdjęć, linia podpisu"
      role="img"
      style={{
        background: '#fbf8f1',
        border: '1.5px solid #14181f',
        borderRadius: 7,
        boxShadow: '10px 10px 0 rgba(20,24,31,0.07)',
        overflow: 'hidden',
        maxWidth: '100%',
      }}
    >
      {/* Window bar */}
      <div
        aria-hidden="true"
        style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '9px 14px',
          borderBottom: '1.5px solid #14181f',
          background: '#efe8db',
        }}
      >
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            style={{ width: 9, height: 9, borderRadius: '50%', border: '1.5px solid #14181f', display: 'inline-block' }}
          />
        ))}
        <span
          style={{
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 10,
            color: '#6b7280', marginLeft: 6, letterSpacing: '0.04em',
          }}
        >protokol-2026-118.pdf</span>
      </div>

      {/* Body */}
      <div style={{ padding: 16 }}>
        {/* Title block */}
        <div
          style={{
            display: 'grid', gridTemplateColumns: '1fr 1fr',
            border: '1.5px solid #14181f', marginBottom: 13,
          }}
        >
          {/* Full-width row: Protokół */}
          <div style={{ gridColumn: '1 / -1', padding: '8px 11px', borderBottom: '1px solid #cdbfa6' }}>
            <div
              style={{
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 8.5,
                letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6b7280',
              }}
            >Protokół</div>
            <div style={{ fontSize: 12.5, fontWeight: 600, marginTop: 2, color: '#14181f' }}>
              Przegląd techniczny budynku
            </div>
          </div>

          {/* Obiekt */}
          <div style={{ padding: '8px 11px', borderRight: '1px solid #cdbfa6', borderBottom: '1px solid #cdbfa6' }}>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 8.5, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6b7280' }}>Obiekt</div>
            <div style={{ fontSize: 12.5, fontWeight: 600, marginTop: 2, color: '#14181f' }}>Centrum Północ</div>
          </div>

          {/* Data */}
          <div style={{ padding: '8px 11px', borderBottom: '1px solid #cdbfa6' }}>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 8.5, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6b7280' }}>Data</div>
            <div style={{ fontSize: 12.5, fontWeight: 600, marginTop: 2, color: '#14181f' }}>07.06.2026</div>
          </div>

          {/* Nr */}
          <div style={{ padding: '8px 11px', borderRight: '1px solid #cdbfa6' }}>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 8.5, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6b7280' }}>Nr</div>
            <div style={{ fontSize: 12.5, fontWeight: 600, marginTop: 2, color: '#14181f' }}>2026/118</div>
          </div>

          {/* Inspektor */}
          <div style={{ padding: '8px 11px' }}>
            <div style={{ fontFamily: "'IBM Plex Mono', monospace", fontSize: 8.5, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#6b7280' }}>Inspektor</div>
            <div style={{ fontSize: 12.5, fontWeight: 600, marginTop: 2, color: '#14181f' }}>A. Kowalski</div>
          </div>
        </div>

        {/* Field rows */}
        {[
          { k: 'Stan instalacji elektrycznej', v: 'Wymaga naprawy', vColor: '#14181f' },
          { k: 'Zawilgocenie ściany (M-18)', v: 'Priorytet wysoki', vColor: '#d9920a' },
          { k: 'Wentylacja', v: 'OK', vColor: '#1f9d6b' },
        ].map((row) => (
          <div
            key={row.k}
            style={{
              display: 'flex', justifyContent: 'space-between',
              fontSize: 12.5, padding: '6px 0',
              borderBottom: '1px dotted #cdbfa6',
            }}
          >
            <span style={{ color: '#3a414e' }}>{row.k}</span>
            <span style={{ fontWeight: 600, color: row.vColor }}>{row.v}</span>
          </div>
        ))}

        {/* Photo thumbnails */}
        <div style={{ display: 'flex', gap: 7, marginTop: 12 }}>
          {['foto 1', 'foto 2', 'foto 3', 'rzut'].map((label) => (
            <div
              key={label}
              style={{
                flex: 1, height: 50,
                border: '1px solid #cdbfa6',
                background: '#efe8db', borderRadius: 5,
                display: 'grid', placeItems: 'center',
                fontFamily: "'IBM Plex Mono', monospace", fontSize: 9, color: '#6b7280',
              }}
            >{label}</div>
          ))}
        </div>

        {/* Signature line */}
        <div
          style={{
            marginTop: 14, paddingTop: 12,
            borderTop: '1.5px solid #14181f',
            display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end',
            fontFamily: "'IBM Plex Mono', monospace", fontSize: 10, color: '#6b7280',
          }}
        >
          <span>
            Inspektor<br />
            <span style={{ display: 'block', width: 120, borderBottom: '1.5px solid #14181f', height: 22 }} />
          </span>
          <span style={{ textAlign: 'right' }}>
            Data<br />i miejsce
          </span>
        </div>
      </div>
    </div>
  );
}
